export const Images = {
  logo: require("./logo.png"),
  avatar: require("./avatar.png")
};
